import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import './HelpPage.css';

function HtsSection(props) {
  var isDark = props.isDark;
  return (
    <div className={'help-reveal help-fade-up help-delay-' + (props.delay || '1') + ' help-section-card'} style={{
      backgroundColor: isDark ? '#141414' : '#fff',
      border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8'),
      borderRadius: '16px',
      padding: '28px',
      marginBottom: '20px',
      boxShadow: '0 2px 12px rgba(0,0,0,0.04)'
    }}>
      <div className="tw-flex tw-items-center tw-gap-3 tw-mb-4">
        <div style={{
          width: '40px', height: '40px', borderRadius: '10px',
          backgroundColor: 'rgba(201,168,76,0.1)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0
        }}>
          <i className={'fa fa-' + props.icon} style={{ color: '#c9a84c', fontSize: '16px' }} />
        </div>
        <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: isDark ? '#fff' : '#1a1a1a' }}>
          {props.title}
        </h2>
      </div>
      <div style={{ color: isDark ? '#d1d5db' : '#4b5563', fontSize: '15px', lineHeight: '1.7' }}>
        {props.children}
      </div>
    </div>
  );
}

function HtsStepNumber(props) {
  return (
    <div style={{
      width: '28px', height: '28px', borderRadius: '50%',
      backgroundColor: '#c9a84c', color: '#000',
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      fontWeight: '700', fontSize: '13px', marginRight: '10px', flexShrink: 0
    }}>
      {props.num}
    </div>
  );
}

function HtsScreenshot(props) {
  var isDark = props.isDark;
  var isMobile = window.innerWidth < 768;
  var src = props.src;
  if (isMobile && isDark) {
    src = src.replace(/\.jpg$/, '-mobile-dark.jpg');
  } else if (isMobile) {
    src = src.replace(/\.jpg$/, '-mobile.jpg');
  } else if (isDark) {
    src = src.replace(/\.jpg$/, '-dark.jpg');
  }
  return (
    <div className="help-screenshot" style={{
      marginTop: '16px',
      marginBottom: '8px',
      borderRadius: '12px',
      overflow: 'hidden',
      border: '1px solid ' + (isDark ? '#2a2a2a' : '#e2e2e2'),
      boxShadow: '0 4px 20px rgba(0,0,0,' + (isDark ? '0.3' : '0.08') + ')'
    }}>
      <img src={src} alt={props.alt || ''} style={{
        width: '100%', display: 'block'
      }} />
    </div>
  );
}

class HowToSell extends Component {
  constructor(props) {
    super(props);
    this.state = { isDark: document.documentElement.classList.contains('tw-dark'), showScrollTop: false };
    this._observer = null;
    this._darkObserver = null;
    this._handleScroll = this._handleScroll.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    var els = document.querySelectorAll('.help-reveal');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('help-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      els.forEach(function(el) { observer.observe(el); });
      this._observer = observer;
    } else {
      els.forEach(function(el) { el.classList.add('help-visible'); });
    }

    window.addEventListener('scroll', this._handleScroll);
    var self = this;
    this._darkObserver = new MutationObserver(function() {
      var dark = document.documentElement.classList.contains('tw-dark');
      if (dark !== self.state.isDark) self.setState({ isDark: dark });
    });
    this._darkObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  componentWillUnmount() {
    if (this._observer) this._observer.disconnect();
    if (this._darkObserver) this._darkObserver.disconnect();
    window.removeEventListener('scroll', this._handleScroll);
  }

  _handleScroll() {
    var show = window.scrollY > 400;
    if (show !== this.state.showScrollTop) this.setState({ showScrollTop: show });
  }

  render() {
    var isDark = this.state.isDark;

    return (
      <div style={{ backgroundColor: isDark ? '#111' : '#f9fafb', minHeight: '100vh' }}>
        <Helmet><title>How to Sell | Primal Market</title></Helmet>

        {/* Hero */}
        <div style={{
          background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
          padding: '60px 20px 48px',
          textAlign: 'center'
        }}>
          <div>
            <div style={{
              width: '56px', height: '56px', borderRadius: '16px',
              backgroundColor: 'rgba(201,168,76,0.15)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 20px'
            }}>
              <i className="fa fa-tag" style={{ color: '#c9a84c', fontSize: '24px' }} />
            </div>
            <h1 style={{ color: '#fff', fontSize: '32px', fontWeight: '700', marginBottom: '12px', marginTop: 0 }}>
              How to Sell
            </h1>
            <p style={{ color: '#9ca3af', fontSize: '16px', maxWidth: '500px', margin: '0 auto', lineHeight: '1.6' }}>
              List your Primal TCG cards in minutes and start earning.
            </p>
          </div>
        </div>

        {/* Content */}
        <div style={{ maxWidth: '720px', margin: '0 auto', padding: '32px 16px 64px' }}>

          <HtsSection isDark={isDark} icon="plus-circle" title="Step 1: Create a Listing" delay="1">
            <p style={{ margin: '0 0 12px' }}>
              Click <strong>"Sell"</strong> in the navigation bar to open the listing form. You can create a single listing or use <strong>Bulk Sell</strong> to list multiple cards at once.
            </p>
            <div style={{ margin: '12px 0' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '12px' }}>
                <HtsStepNumber num="1" />
                <div><strong>Search for your card</strong> — Type the card name and select it from the dropdown. The card details (set, rarity, image) will auto-fill.</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '12px' }}>
                <HtsStepNumber num="2" />
                <div><strong>Select condition</strong> — Choose from Near Mint, Lightly Played, Moderately Played, Heavily Played, or Damaged. Foil and non-foil conditions are grouped separately.</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                <HtsStepNumber num="3" />
                <div><strong>Set quantity</strong> — How many copies of this card you're selling.</div>
              </div>
            </div>
            <HtsScreenshot isDark={isDark} src="/help/sell-search.jpg" alt="Sell page card search with dropdown results" />
          </HtsSection>

          <HtsSection isDark={isDark} icon="usd" title="Step 2: Set Your Price" delay="2">
            <p style={{ margin: '0 0 12px' }}>
              Enter your asking price. The minimum listing price is <strong>$0.75</strong>. You'll see a live breakdown of:
            </p>
            <ul style={{ margin: '0 0 12px', paddingLeft: '20px' }}>
              <li style={{ marginBottom: '6px' }}><strong>Platform fee</strong> — You keep 90% of your item price (on orders under $9, payout may be slightly lower to cover processing)</li>
              <li style={{ marginBottom: '6px' }}><strong>Your payout</strong> — What you'll receive after fees</li>
              <li style={{ marginBottom: '6px' }}><strong>Shipping cost</strong> — Set your shipping price or offer free shipping</li>
            </ul>
            <p style={{ margin: 0 }}>
              You can also toggle <strong>"Open to Offers"</strong> to let buyers negotiate a price with you.
            </p>
            <HtsScreenshot isDark={isDark} src="/help/sell-pricing.jpg" alt="Pricing step with market price comparison" />
          </HtsSection>

          <HtsSection isDark={isDark} icon="camera" title="Step 3: Add Photos" delay="3">
            <p style={{ margin: '0 0 12px' }}>
              Upload photos of your actual card. Good photos help sell cards faster. Tips:
            </p>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li style={{ marginBottom: '6px' }}>Use good lighting — natural light works best</li>
              <li style={{ marginBottom: '6px' }}>Show the front and back of the card</li>
              <li style={{ marginBottom: '6px' }}>Photograph any damage or wear clearly</li>
              <li style={{ marginBottom: '6px' }}>Place the card on a clean, contrasting background</li>
            </ul>
          </HtsSection>

          <HtsSection isDark={isDark} icon="pencil" title="Editing Your Listings" delay="4">
            <p style={{ margin: '0 0 12px' }}>
              After publishing, you can edit your listings at any time from your shop page:
            </p>
            <ul style={{ margin: '0 0 12px', paddingLeft: '20px' }}>
              <li style={{ marginBottom: '6px' }}><strong>Change price</strong> — Update your asking price</li>
              <li style={{ marginBottom: '6px' }}><strong>Update quantity</strong> — Adjust available stock</li>
              <li style={{ marginBottom: '6px' }}><strong>Edit description</strong> — Add or modify listing details</li>
              <li style={{ marginBottom: '6px' }}><strong>Delete listing</strong> — Remove it from the marketplace</li>
            </ul>
            <p style={{ margin: 0 }}>
              Visit your profile page and click the <strong>"Edit"</strong> button on any of your active listings.
            </p>
            <HtsScreenshot isDark={isDark} src="/help/sell-details.jpg" alt="Editing card details, description, and listing options" />
          </HtsSection>

          <HtsSection isDark={isDark} icon="truck" title="Shipping Your Cards" delay="5">
            <p style={{ margin: '0 0 12px' }}>
              When a buyer purchases your card, you'll receive a notification. Ship the card within a reasonable timeframe and add tracking information to the order.
            </p>
            <p style={{ margin: 0 }}>
              For detailed shipping guidelines, check our{' '}
              <Link to="/shipping" style={{ color: '#c9a84c', textDecoration: 'none' }}>Shipping Guide</Link>.
            </p>
          </HtsSection>

          {/* CTA */}
          <div className="help-reveal help-fade-up help-delay-6" style={{ textAlign: 'center', marginTop: '40px' }}>
            <Link to="/sell" className="tw-no-underline help-cta-btn" style={{
              display: 'inline-block', backgroundColor: '#c9a84c', color: '#000',
              fontWeight: '600', fontSize: '15px', padding: '12px 32px',
              borderRadius: '10px', textDecoration: 'none'
            }}>
              Start Selling
            </Link>
          </div>
        </div>

        {this.state.showScrollTop && (
          <button
            onClick={function () { window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="tw-fixed tw-bottom-6 tw-right-6 tw-w-10 tw-h-10 tw-rounded-full tw-bg-brand-gold tw-text-black tw-border-0 tw-cursor-pointer tw-z-40 tw-flex tw-items-center tw-justify-center"
            style={{ boxShadow: '0 4px 16px rgba(201, 168, 76, 0.3)' }}
            aria-label="Scroll to top"
          >
            <svg className="tw-w-6 tw-h-6" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
          </button>
        )}
      </div>
    );
  }
}

export default HowToSell;
